namespace GeniuzPOS.ReportMasterData {
    export interface Report_1411Form {
    }

    export class Report_1411Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1411';
    }
}
